import getVideoId from 'get-video-id'

/**
 * Given a Vimeo or YouTube URL, get the id and service name
 *
 * @param { string } videoURL - YouTube or Vimeo URL (usually copied from the browser URL bar)
 * @returns { id: string, service: string } - object with video ID and name of service
 */
export function getVideoDetails(videoURL) {
  return getVideoId(videoURL)
}

/**
 * Get corresponding iframe element, given video title, id and name of service (either 'youtube' or 'vimeo')
 *
 * @param { string } title - Descriptive title of video
 * @param { string } id - ID of video
 * @param { 'youtube' | 'vimeo' } service - name of video platform
 * @returns { HTMLElement } - iframe element
 */
export function getEmbedCode(title, id, service) {
  let embedEl = document.createElement('iframe')

  // Set shared attributes on iframe element
  embedEl.classList.add('c-video-container__iframe')
  embedEl.setAttribute('width', '560')
  embedEl.setAttribute('height', '315')
  embedEl.setAttribute('title', title)
  embedEl.setAttribute('frameborder', '0')
  embedEl.setAttribute('allowfullscreen', true)

  // Set YouTube specific attributes on element
  if (service === 'youtube') {
    embedEl.setAttribute('src', `https://www.youtube.com/embed/${id}?si=GvxVgTOGBf88KVNc`)
    embedEl.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;',
    )
    embedEl.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin')

    // Set Vimeo specific attributes on element
  } else if (service === 'vimeo') {
    embedEl.setAttribute('src', `https://player.vimeo.com/video/${id}`)
  }

  return embedEl
}
